// 课程表相关类型定义

// 单个课程信息
export const CourseType = {
  sub: '', // 课程名称
  tec: '', // 教师姓名
  week: '', // 周次信息
  add: '', // 上课地点
  color: '' // 课程颜色（可选）
};

// 一天的课程安排（数组，包含课程或数字0表示空节）
export const DayScheduleType = [];

// 完整的课程表（1-7表示周一到周日）
export const ScheduleType = {
  1: [], // 周一
  2: [], // 周二
  3: [], // 周三
  4: [], // 周四
  5: [], // 周五
  6: [], // 周六
  7: []  // 周日
};

// 时间表配置
export const TimeTableType = {
  fen: [2, 2, 1], // 时间段分割：1-4节，5-8节，9-10节
  time: [
    { timeStart: "08:20", timeEnd: "09:05" },
    { timeStart: "09:15", timeEnd: "10:00" },
    { timeStart: "10:20", timeEnd: "11:05" },
    { timeStart: "11:15", timeEnd: "12:00" },
    { timeStart: "13:40", timeEnd: "14:25" },
    { timeStart: "14:35", timeEnd: "15:20" },
    { timeStart: "15:40", timeEnd: "16:25" },
    { timeStart: "16:35", timeEnd: "17:20" },
    { timeStart: "18:10", timeEnd: "18:55" },
    { timeStart: "19:05", timeEnd: "19:50" }
  ]
};

// 周次列表项
export const WeekDayItemType = {
  isCurr: false,
  week: '',
  day: ''
};
